/**
 * Pinky Header and Footer Main Library
 */
import $ from 'jquery';
import Modernizr from 'modernizr';
import 'jquery-hoverIntent';
import 'jquery-ba-outside-events';
import { qtsp } from '@shared/tracking-qtsbinds';
import announcements from '@shared/announcements';
import warningBanners from '@shared/warning-banners';
import '@shared/sticky-navigation';
import '@shared/facebook-sdk';

$(document).ready(() => {
  // Initialise warning and announcements banners
  warningBanners.init();
  announcements.init();

  const $popoverTriggers = $('#fm-header, #default-header')
    .find('.clickover[data-show_on_hover=true]');

  if (!Modernizr.touch) {
    $popoverTriggers.each(function () {
      const popoverHandler = $(this);
      let popover;

      let popoverEnterTimeout;
      let popoverLeaveTimeout;

      let isHoverPopover;

      // Due to mutual recursion between these functions we define them all
      // here in one place.
      let clearPopoverEnterTimeout;
      let clearPopoverLeaveTimeout;
      let removeEventListeners;

      const setPopoverEnterTimeout = () => {
        popoverEnterTimeout = setTimeout(() => {
          if (popover.hasClass('popover') &&
            !popover.is(':hidden')) {
            removeEventListeners();
            clearPopoverLeaveTimeout();
            popoverHandler.trigger('popover:click');
          }
        }, 250);
      };

      const setPopoverLeaveTimeout = () => {
        popoverLeaveTimeout = setTimeout(() => {
          if (popover.hasClass('popover') &&
            !popover.is(':hidden')) {
            removeEventListeners();
            clearPopoverEnterTimeout();
            popoverHandler.trigger('popover:click');
          }
        }, 200);
      };

      clearPopoverEnterTimeout = () => {
        clearTimeout(popoverEnterTimeout);
      };

      clearPopoverLeaveTimeout = () => {
        clearTimeout(popoverLeaveTimeout);
      };

      removeEventListeners = () => {
        popover.off('mouseenter', clearPopoverEnterTimeout);
        popover.off('mouseleave', setPopoverLeaveTimeout);
        popover.off('mouseenter', clearPopoverLeaveTimeout);
      };

      popoverHandler.hoverIntent({
        over() {
          popover = popoverHandler.next();
          clearPopoverLeaveTimeout();
          clearPopoverEnterTimeout();
          // Don't if already there
          if (!popover.hasClass('popover') ||
            (popover.hasClass('popover') &&
              popover.is(':hidden'))) {
            popoverHandler.trigger('popover:click');
          }
        },
        out() {
          // Mouse is out of the menu button
          popover = popoverHandler.next();
          // Do nothing if already gone
          if (popover.hasClass('popover') &&
            !popover.is(':hidden')) {
            // Set maximum delay for entering the popover
            setPopoverEnterTimeout();
            // Clear enter timer when inside the popover
            popover.on('mouseenter', clearPopoverEnterTimeout);
            // Set maximum delay when exiting the popover
            popover.on('mouseleave', setPopoverLeaveTimeout);
            // Reset the leave delay when inside the popover again
            popover.on('mouseenter', clearPopoverLeaveTimeout);
            // If already inside the popover, clear the timeout.
            // Can't use is(:hover) css selector because not
            // in IE < 9.
            if (isHoverPopover) {
              clearPopoverEnterTimeout();
            }
          }
        },
        interval: 30,
      });

      // Delegated "hover" event handlers from is(:hover)-like behavior
      popoverHandler.parent().on('mouseenter', '.popover', () => {
        isHoverPopover = true;
      });
      popoverHandler.parent().on('mouseleave', '.popover', () => {
        isHoverPopover = false;
      });
    });
  } else {
    $popoverTriggers.each(function () {
      $(this).on('click', function () {
        $(this).trigger('popover:click');
      });
    });
  }

  qtsp.init({
    section: 'NavBar',
    action: 'click',
  }, true);

  qtsp.bind('[data-qts]', {}, true);
});
